/**
 * @generated SignedSource<<430b3c259ade81fa23ea1deefa2e0d2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgendaMemberNoteStatus = "HIGH" | "MEDIUM" | "STANDARD";
export type BookingWriteAccess = "FULL_WRITE" | "JOIN" | "NONE" | "NON_OWNER_WRITE";
export type ClubVisibility = "PRIVATE" | "PUBLIC" | "SEMI_PRIVATE";
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
export type EventSlotType = "BUFFER" | "EVENT";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type MeasurementSystem = "IMPERIAL" | "METRIC";
export type RateType = "CUSTOMER" | "GUEST" | "LESSON" | "MEMBER";
export type RestrictionMemberVisibility = "NONE" | "RESTRICTION_ONLY" | "SLOTS_AND_RESTRICTION" | "SLOTS_AND_RESTRICTION_INLINE" | "SLOTS_ONLY";
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
export type WeatherStatus = "ASH" | "CLEAR" | "CLOUDS" | "DRIZZLE" | "DUST" | "FOG" | "HAZE" | "MIST" | "RAIN" | "SAND" | "SMOKE" | "SNOW" | "SQUALL" | "THUNDERSTORM" | "TORNADO";
export type TimeSlotListInternalQuery$variables = {
  courseIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  date: string;
  facilityId: string;
  isCustomer: boolean;
  memberId: string;
  membershipTypeId: string;
  requestConfigs: boolean;
};
export type TimeSlotListInternalQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly agendas?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly blockingRestrictions: {
            readonly edges: ReadonlyArray<{
              readonly liftAt: string | null | undefined;
              readonly node: {
                readonly displayName: string | null | undefined;
                readonly id: string;
                readonly liftBookingRuleWindow?: {
                  readonly daysAhead: number;
                  readonly time: string;
                } | null | undefined;
                readonly memberMessage?: string | null | undefined;
                readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
                readonly name: string;
                readonly slotCriteria?: {
                  readonly allDay: boolean;
                  readonly courses: {
                    readonly count: number;
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly id: string;
                        readonly name: string;
                      } | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly endAt: string | null | undefined;
                  readonly startAt: string | null | undefined;
                } | null | undefined;
                readonly visibilityColor?: CustomColor | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly blocks: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly blockSeries: {
                  readonly color: CustomColor;
                  readonly name: string;
                };
                readonly courses: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly id: string;
                      readonly name: string;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly durationMins: number | null | undefined;
                readonly id: string;
                readonly startAt: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly configuredRequestRestrictions?: {
            readonly edges: ReadonlyArray<{
              readonly liftAt: string | null | undefined;
              readonly node: {
                readonly displayName: string | null | undefined;
                readonly id: string;
                readonly liftBookingRuleWindow?: {
                  readonly daysAhead: number;
                  readonly time: string;
                } | null | undefined;
                readonly memberMessage?: string | null | undefined;
                readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
                readonly name: string;
                readonly requestConfig?: {
                  readonly closedRequestMessage: string | null | undefined;
                  readonly id: string;
                } | null | undefined;
                readonly slotCriteria?: {
                  readonly allDay: boolean;
                  readonly courses: {
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly id: string;
                      } | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly endAt: string | null | undefined;
                  readonly startAt: string | null | undefined;
                } | null | undefined;
                readonly visibilityColor?: CustomColor | null | undefined;
              } | null | undefined;
              readonly requestCloses: string | null | undefined;
              readonly requestOpens: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly date: string;
          readonly events: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly eventSeries: {
                  readonly name: string;
                };
                readonly eventSessions: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly agenda: {
                        readonly date: string;
                      };
                      readonly courses: {
                        readonly edges: ReadonlyArray<{
                          readonly node: {
                            readonly id: string;
                            readonly name: string;
                          } | null | undefined;
                        } | null | undefined> | null | undefined;
                      } | null | undefined;
                      readonly endAt: string | null | undefined;
                      readonly id: string;
                      readonly name: string | null | undefined;
                      readonly startAt: string | null | undefined;
                      readonly timeSlots: {
                        readonly firstDateTime: string | null | undefined;
                        readonly lastDateTime: string | null | undefined;
                      } | null | undefined;
                      readonly " $fragmentSpreads": FragmentRefs<"TimeListEventsCard_EventSession">;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly id: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly infoRestrictions: {
            readonly edges: ReadonlyArray<{
              readonly liftAt: string | null | undefined;
              readonly node: {
                readonly displayName: string | null | undefined;
                readonly id: string;
                readonly memberMessage?: string | null | undefined;
                readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
                readonly name: string;
                readonly slotCriteria?: {
                  readonly allDay: boolean;
                  readonly courses: {
                    readonly count: number;
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly id: string;
                        readonly name: string;
                      } | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly endAt: string | null | undefined;
                  readonly startAt: string | null | undefined;
                } | null | undefined;
                readonly visibilityColor?: CustomColor | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly memberNote: {
            readonly body: string;
            readonly header: string;
            readonly id: string;
            readonly status: AgendaMemberNoteStatus;
          } | null | undefined;
          readonly queueSlot: {
            readonly id: string;
            readonly queueCount: {
              readonly count: number;
            } | null | undefined;
          };
          readonly requestRestrictions?: {
            readonly edges: ReadonlyArray<{
              readonly liftAt: string | null | undefined;
              readonly node: {
                readonly displayName: string | null | undefined;
                readonly id: string;
                readonly liftBookingRuleWindow?: {
                  readonly daysAhead: number;
                  readonly time: string;
                } | null | undefined;
                readonly memberMessage?: string | null | undefined;
                readonly name: string;
                readonly slotCriteria?: {
                  readonly allDay: boolean;
                  readonly courses: {
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly id: string;
                      } | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly endAt: string | null | undefined;
                  readonly startAt: string | null | undefined;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly timeSlots: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly availability: SlotAvailability;
                readonly block: {
                  readonly blockSeries: {
                    readonly color: CustomColor;
                    readonly isVisibleToMembers: boolean;
                    readonly name: string;
                  };
                  readonly courses: {
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly id: string;
                      } | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly durationMins: number | null | undefined;
                  readonly id: string;
                  readonly startAt: string;
                } | null | undefined;
                readonly bookings: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly rounds: {
                        readonly edges: ReadonlyArray<{
                          readonly node: {
                            readonly __typename: string;
                            readonly player: {
                              readonly __typename: string;
                              readonly firstName: string | null | undefined;
                              readonly id: string;
                              readonly lastName: string | null | undefined;
                            } | null | undefined;
                          } | null | undefined;
                        } | null | undefined> | null | undefined;
                      } | null | undefined;
                      readonly writeAccess: BookingWriteAccess | null | undefined;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly capacity: number;
                readonly configuredRequestRestrictions?: {
                  readonly edges: ReadonlyArray<{
                    readonly liftAt: string | null | undefined;
                    readonly node: {
                      readonly displayName: string | null | undefined;
                      readonly id: string;
                      readonly liftBookingRuleWindow?: {
                        readonly daysAhead: number;
                        readonly time: string;
                      } | null | undefined;
                      readonly memberMessage?: string | null | undefined;
                      readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
                      readonly name: string;
                      readonly requestConfig?: {
                        readonly closedRequestMessage: string | null | undefined;
                        readonly id: string;
                      } | null | undefined;
                      readonly slotCriteria?: {
                        readonly allDay: boolean;
                        readonly endAt: string | null | undefined;
                        readonly startAt: string | null | undefined;
                      } | null | undefined;
                      readonly visibilityColor?: CustomColor | null | undefined;
                    } | null | undefined;
                    readonly requestCloses: string | null | undefined;
                    readonly requestOpens: string | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly course: {
                  readonly id: string;
                  readonly name: string;
                };
                readonly dateTime: string | null | undefined;
                readonly eventSlot: {
                  readonly eventSession: {
                    readonly id: string;
                  };
                  readonly type: EventSlotType;
                } | null | undefined;
                readonly hasHiddenBlockingRestriction: boolean;
                readonly hiddenBlockingRestrictions: {
                  readonly edges: ReadonlyArray<{
                    readonly liftAt: string | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly id: string;
                readonly permittedCourseLayouts: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly holeCount: HoleCount;
                      readonly id: string;
                      readonly name: string;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly playerRateForMembershipType: {
                  readonly eighteenHolePrice: number | null | undefined;
                  readonly nineHolePrice: number | null | undefined;
                  readonly rate: {
                    readonly code: string;
                    readonly id: string;
                    readonly name: string;
                    readonly type: RateType;
                  };
                } | null | undefined;
                readonly requestRestrictions?: {
                  readonly edges: ReadonlyArray<{
                    readonly liftAt: string | null | undefined;
                    readonly node: {
                      readonly displayName: string | null | undefined;
                      readonly id: string;
                      readonly liftBookingRuleWindow?: {
                        readonly daysAhead: number;
                        readonly time: string;
                      } | null | undefined;
                      readonly memberMessage?: string | null | undefined;
                      readonly name: string;
                      readonly slotCriteria?: {
                        readonly allDay: boolean;
                        readonly endAt: string | null | undefined;
                        readonly startAt: string | null | undefined;
                      } | null | undefined;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly time: string;
                readonly usedCapacity: number;
                readonly waitlistRestrictions: {
                  readonly edges: ReadonlyArray<{
                    readonly liftAt: string | null | undefined;
                    readonly node: {
                      readonly id: string;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly " $fragmentSpreads": FragmentRefs<"TimeSlotRow_Timeslot">;
              } | null | undefined;
            } | null | undefined> | null | undefined;
            readonly firstDateTime: string | null | undefined;
          } | null | undefined;
          readonly waitlistRestrictions: {
            readonly edges: ReadonlyArray<{
              readonly liftAt: string | null | undefined;
              readonly node: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly weatherConditions: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly humidityInPercent: number;
                readonly id: string;
                readonly measurementSystem: MeasurementSystem;
                readonly probabilityOfPrecipitationInPercent: number;
                readonly startTime: string;
                readonly temperature: number;
                readonly weatherCategory: WeatherStatus;
                readonly windDegrees: number;
                readonly windSpeedInMph: number;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly club?: {
      readonly supportsPublic: boolean;
    } | null | undefined;
    readonly courses?: {
      readonly count: number;
    } | null | undefined;
    readonly id: string;
    readonly type?: FacilityType;
    readonly " $fragmentSpreads": FragmentRefs<"getFacilityMemberPermissions_facility" | "useGetCanClientFulFillRequests_facility">;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly id: string;
          readonly supportsPublic: boolean;
          readonly visibility: ClubVisibility;
        };
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type TimeSlotListInternalQuery = {
  response: TimeSlotListInternalQuery$data;
  variables: TimeSlotListInternalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCustomer"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestConfigs"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPrivate",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFacilityVisible",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFacilityBookable",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areOtherBookingsVisible",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areOtherBookingsJoinable",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBookOnBusySlot",
  "storageKey": null
},
v18 = [
  (v7/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v23 = [
  {
    "kind": "Variable",
    "name": "dateGte",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "dateLte",
    "variableName": "date"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "QueueSlot",
  "kind": "LinkedField",
  "name": "queueSlot",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": "queueCount",
      "args": null,
      "concreteType": "BookingConnection",
      "kind": "LinkedField",
      "name": "bookings",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "AgendaMemberNote",
  "kind": "LinkedField",
  "name": "memberNote",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    (v26/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "kind": "Literal",
  "name": "bookingType",
  "value": [
    "STANDARD"
  ]
},
v29 = {
  "kind": "Variable",
  "name": "courseIds",
  "variableName": "courseIds"
},
v30 = {
  "kind": "Literal",
  "name": "isBlocking",
  "value": true
},
v31 = {
  "kind": "Literal",
  "name": "type",
  "value": [
    "RESTRICTION"
  ]
},
v32 = [
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  {
    "kind": "Literal",
    "name": "memberVisibility",
    "value": [
      "RESTRICTION_ONLY",
      "SLOTS_AND_RESTRICTION",
      "NONE"
    ]
  },
  (v31/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberMessage",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityColor",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberVisibility",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysAhead",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleWindow",
  "kind": "LinkedField",
  "name": "liftBookingRuleWindow",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allDay",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v45 = [
  (v7/*: any*/),
  (v34/*: any*/)
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v45/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v46/*: any*/)
  ],
  "storageKey": null
},
v48 = [
  (v29/*: any*/),
  {
    "kind": "Literal",
    "name": "isBlocking",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "memberVisibility",
    "value": [
      "RESTRICTION_ONLY",
      "SLOTS_AND_RESTRICTION"
    ]
  },
  (v31/*: any*/)
],
v49 = [
  (v34/*: any*/),
  (v7/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v49/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = {
  "kind": "Literal",
  "name": "type",
  "value": [
    "WAITLIST"
  ]
},
v52 = [
  (v29/*: any*/),
  (v51/*: any*/)
],
v53 = [
  (v7/*: any*/)
],
v54 = [
  (v33/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v53/*: any*/),
    "storageKey": null
  }
],
v55 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v56 = [
  (v55/*: any*/),
  {
    "kind": "Literal",
    "name": "isVisibleToMembers",
    "value": true
  }
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMins",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    (v46/*: any*/)
  ],
  "storageKey": null
},
v60 = [
  (v29/*: any*/)
],
v61 = [
  (v55/*: any*/)
],
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstDateTime",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeSlotConnection",
  "kind": "LinkedField",
  "name": "timeSlots",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastDateTime",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = [
  (v29/*: any*/),
  (v55/*: any*/)
],
v65 = {
  "kind": "Variable",
  "name": "membershipTypeId",
  "variableName": "membershipTypeId"
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateTime",
  "storageKey": null
},
v67 = {
  "kind": "Literal",
  "name": "type",
  "value": "CUSTOMER"
},
v68 = [
  (v65/*: any*/),
  (v67/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v70 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "NINE"
  }
],
v71 = {
  "alias": "nineHolePrice",
  "args": (v70/*: any*/),
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
},
v72 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "EIGHTEEN"
  }
],
v73 = {
  "alias": "eighteenHolePrice",
  "args": (v72/*: any*/),
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
},
v74 = {
  "kind": "Literal",
  "name": "memberVisible",
  "value": true
},
v75 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v74/*: any*/)
],
v76 = {
  "alias": null,
  "args": (v75/*: any*/),
  "concreteType": "CourseLayoutConnection",
  "kind": "LinkedField",
  "name": "permittedCourseLayouts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseLayoutEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseLayout",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v34/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "holeCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "permittedCourseLayouts(first:10,memberVisible:true)"
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availability",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "bookingType",
      "value": "STANDARD"
    }
  ],
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": "capacity(bookingType:\"STANDARD\")"
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedCapacity",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVisibleToMembers",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v53/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "Course",
  "kind": "LinkedField",
  "name": "course",
  "plural": false,
  "selections": (v45/*: any*/),
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "EventSession",
  "kind": "LinkedField",
  "name": "eventSession",
  "plural": false,
  "selections": (v53/*: any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "writeAccess",
  "storageKey": null
},
v85 = [
  {
    "kind": "Literal",
    "name": "noShowStatus",
    "value": [
      "PRESENT"
    ]
  }
],
v86 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v87 = {
  "kind": "Literal",
  "name": "type",
  "value": [
    "REQUEST"
  ]
},
v88 = [
  (v87/*: any*/)
],
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/)
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestOpens",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "RequestConfig",
  "kind": "LinkedField",
  "name": "requestConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedRequestMessage",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v93 = {
  "alias": "hiddenBlockingRestrictions",
  "args": [
    (v28/*: any*/),
    (v30/*: any*/),
    {
      "kind": "Literal",
      "name": "memberVisibility",
      "value": [
        "RESTRICTION_ONLY",
        "NONE"
      ]
    },
    (v31/*: any*/)
  ],
  "concreteType": "SlotBookingRulesConnection",
  "kind": "LinkedField",
  "name": "bookingRules",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SlotBookingRulesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v33/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "bookingRules(bookingType:[\"STANDARD\"],isBlocking:true,memberVisibility:[\"RESTRICTION_ONLY\",\"NONE\"],type:[\"RESTRICTION\"])"
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasHiddenBlockingRestriction",
  "storageKey": null
},
v95 = [
  (v51/*: any*/)
],
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v81/*: any*/)
  ],
  "storageKey": null
},
v97 = [
  (v29/*: any*/),
  (v87/*: any*/)
],
v98 = {
  "alias": null,
  "args": (v61/*: any*/),
  "concreteType": "WeatherConditionConnection",
  "kind": "LinkedField",
  "name": "weatherConditions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WeatherConditionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WeatherCondition",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTime",
              "storageKey": null
            },
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weatherCategory",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "probabilityOfPrecipitationInPercent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementSystem",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "temperature",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "humidityInPercent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "windDegrees",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "windSpeedInMph",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "weatherConditions(first:1000)"
},
v99 = {
  "kind": "InlineFragment",
  "selections": (v53/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v100 = [
  (v7/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientCanFulfillRequests",
    "storageKey": null
  }
],
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleWindow",
  "kind": "LinkedField",
  "name": "liftBookingRuleWindow",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v40/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v102 = [
  (v33/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      (v7/*: any*/)
    ],
    "storageKey": null
  }
],
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "Agenda",
  "kind": "LinkedField",
  "name": "agenda",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v104 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v105 = [
  (v26/*: any*/)
],
v106 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      (v7/*: any*/),
      (v34/*: any*/),
      (v22/*: any*/),
      (v69/*: any*/)
    ],
    "storageKey": null
  },
  (v71/*: any*/),
  (v73/*: any*/)
],
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v81/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeSlotListInternalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v11/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "getFacilityMemberPermissions_facility",
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicBookingPermissionSet",
                    "kind": "LinkedField",
                    "name": "publicBookingPermissionSet",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PrivateBookingPermissionSet",
                    "kind": "LinkedField",
                    "name": "privateBookingPermissionSet",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useGetCanClientFulFillRequests_facility"
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": "blockingRestrictions",
                            "args": (v32/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v41/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingRuleSlotCriteria",
                                            "kind": "LinkedField",
                                            "name": "slotCriteria",
                                            "plural": false,
                                            "selections": [
                                              (v42/*: any*/),
                                              (v43/*: any*/),
                                              (v44/*: any*/),
                                              (v47/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "BookingRestrictionRule",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "infoRestrictions",
                            "args": (v48/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingRuleSlotCriteria",
                                            "kind": "LinkedField",
                                            "name": "slotCriteria",
                                            "plural": false,
                                            "selections": [
                                              (v42/*: any*/),
                                              (v43/*: any*/),
                                              (v44/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "BookingRestrictionRule",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "waitlistRestrictions",
                            "args": (v52/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v54/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v56/*: any*/),
                            "concreteType": "TimeSlotBlockConnection",
                            "kind": "LinkedField",
                            "name": "blocks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlotBlockEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeSlotBlock",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v43/*: any*/),
                                      (v57/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BlockSeries",
                                        "kind": "LinkedField",
                                        "name": "blockSeries",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v58/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v59/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "blocks(first:1000,isVisibleToMembers:true)"
                          },
                          {
                            "alias": null,
                            "args": (v60/*: any*/),
                            "concreteType": "EventConnection",
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSeries",
                                        "kind": "LinkedField",
                                        "name": "eventSeries",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": (v61/*: any*/),
                                        "concreteType": "EventSessionConnection",
                                        "kind": "LinkedField",
                                        "name": "eventSessions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSessionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventSession",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v43/*: any*/),
                                                  (v44/*: any*/),
                                                  (v59/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Agenda",
                                                    "kind": "LinkedField",
                                                    "name": "agenda",
                                                    "plural": false,
                                                    "selections": [
                                                      (v24/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v34/*: any*/),
                                                  (v63/*: any*/),
                                                  {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "TimeListEventsCard_EventSession"
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "eventSessions(first:1000)"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v64/*: any*/),
                            "concreteType": "TimeSlotConnection",
                            "kind": "LinkedField",
                            "name": "timeSlots",
                            "plural": false,
                            "selections": [
                              (v62/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlotEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeSlot",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "args": [
                                          (v65/*: any*/)
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "TimeSlotRow_Timeslot"
                                      },
                                      (v7/*: any*/),
                                      (v40/*: any*/),
                                      (v66/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v68/*: any*/),
                                        "concreteType": "SlotRate",
                                        "kind": "LinkedField",
                                        "name": "playerRateForMembershipType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "rate",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v34/*: any*/),
                                              (v22/*: any*/),
                                              (v69/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v71/*: any*/),
                                          (v73/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v76/*: any*/),
                                      (v77/*: any*/),
                                      (v78/*: any*/),
                                      (v79/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimeSlotBlock",
                                        "kind": "LinkedField",
                                        "name": "block",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v43/*: any*/),
                                          (v57/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BlockSeries",
                                            "kind": "LinkedField",
                                            "name": "blockSeries",
                                            "plural": false,
                                            "selections": [
                                              (v80/*: any*/),
                                              (v34/*: any*/),
                                              (v58/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v81/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v82/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSlot",
                                        "kind": "LinkedField",
                                        "name": "eventSlot",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v83/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BookingConnection",
                                        "kind": "LinkedField",
                                        "name": "bookings",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v84/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": (v85/*: any*/),
                                                    "concreteType": "RoundConnection",
                                                    "kind": "LinkedField",
                                                    "name": "rounds",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "RoundEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v86/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": "rounds(noShowStatus:[\"PRESENT\"])"
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "condition": "requestConfigs",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "alias": "requestRestrictions",
                                            "args": (v88/*: any*/),
                                            "concreteType": "SlotBookingRulesConnection",
                                            "kind": "LinkedField",
                                            "name": "bookingRules",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SlotBookingRulesEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v33/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v7/*: any*/),
                                                      (v34/*: any*/),
                                                      (v35/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v36/*: any*/),
                                                          (v41/*: any*/),
                                                          (v89/*: any*/)
                                                        ],
                                                        "type": "RequestRule",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "bookingRules(type:[\"REQUEST\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "requestConfigs",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "alias": "configuredRequestRestrictions",
                                            "args": (v88/*: any*/),
                                            "concreteType": "SlotBookingRulesConnection",
                                            "kind": "LinkedField",
                                            "name": "requestWindowBookingRules",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SlotBookingRulesEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v33/*: any*/),
                                                  (v90/*: any*/),
                                                  (v91/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v7/*: any*/),
                                                      (v34/*: any*/),
                                                      (v35/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v36/*: any*/),
                                                          (v92/*: any*/),
                                                          (v38/*: any*/),
                                                          (v37/*: any*/),
                                                          (v41/*: any*/),
                                                          (v89/*: any*/)
                                                        ],
                                                        "type": "RequestRule",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                                          }
                                        ]
                                      },
                                      (v93/*: any*/),
                                      (v94/*: any*/),
                                      {
                                        "alias": "waitlistRestrictions",
                                        "args": (v95/*: any*/),
                                        "concreteType": "SlotBookingRulesConnection",
                                        "kind": "LinkedField",
                                        "name": "bookingRules",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SlotBookingRulesEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v54/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "alias": "requestRestrictions",
                                "args": (v88/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "bookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v33/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v36/*: any*/),
                                              (v41/*: any*/),
                                              (v96/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "bookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "configuredRequestRestrictions",
                                "args": (v97/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "requestWindowBookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v33/*: any*/),
                                      (v90/*: any*/),
                                      (v91/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v36/*: any*/),
                                              (v92/*: any*/),
                                              (v38/*: any*/),
                                              (v37/*: any*/),
                                              (v41/*: any*/),
                                              (v96/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          (v98/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "TimeSlotListInternalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v9/*: any*/),
                  (v99/*: any*/)
                ],
                "storageKey": null
              },
              (v99/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v11/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PublicBookingPermissionSet",
                "kind": "LinkedField",
                "name": "publicBookingPermissionSet",
                "plural": false,
                "selections": (v100/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PrivateBookingPermissionSet",
                "kind": "LinkedField",
                "name": "privateBookingPermissionSet",
                "plural": false,
                "selections": (v100/*: any*/),
                "storageKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": "blockingRestrictions",
                            "args": (v32/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v7/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v101/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingRuleSlotCriteria",
                                            "kind": "LinkedField",
                                            "name": "slotCriteria",
                                            "plural": false,
                                            "selections": [
                                              (v42/*: any*/),
                                              (v43/*: any*/),
                                              (v44/*: any*/),
                                              (v47/*: any*/),
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "BookingRestrictionRule",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "infoRestrictions",
                            "args": (v48/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v7/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingRuleSlotCriteria",
                                            "kind": "LinkedField",
                                            "name": "slotCriteria",
                                            "plural": false,
                                            "selections": [
                                              (v42/*: any*/),
                                              (v43/*: any*/),
                                              (v44/*: any*/),
                                              (v50/*: any*/),
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "BookingRestrictionRule",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "waitlistRestrictions",
                            "args": (v52/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v102/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v56/*: any*/),
                            "concreteType": "TimeSlotBlockConnection",
                            "kind": "LinkedField",
                            "name": "blocks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlotBlockEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeSlotBlock",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v43/*: any*/),
                                      (v57/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BlockSeries",
                                        "kind": "LinkedField",
                                        "name": "blockSeries",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v58/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v59/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "blocks(first:1000,isVisibleToMembers:true)"
                          },
                          {
                            "alias": null,
                            "args": (v60/*: any*/),
                            "concreteType": "EventConnection",
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSeries",
                                        "kind": "LinkedField",
                                        "name": "eventSeries",
                                        "plural": false,
                                        "selections": (v49/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": (v61/*: any*/),
                                        "concreteType": "EventSessionConnection",
                                        "kind": "LinkedField",
                                        "name": "eventSessions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSessionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventSession",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v43/*: any*/),
                                                  (v44/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "courses",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CourseEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Course",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v7/*: any*/),
                                                              (v34/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "CourseBucket",
                                                                "kind": "LinkedField",
                                                                "name": "courseBucket",
                                                                "plural": false,
                                                                "selections": (v49/*: any*/),
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v103/*: any*/),
                                                  (v34/*: any*/),
                                                  (v63/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "bookingsPublishedAt",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayTime",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                      (v7/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "EventTagConnection",
                                                        "kind": "LinkedField",
                                                        "name": "tags",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTagEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventTag",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v49/*: any*/),
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v104/*: any*/),
                                                        "concreteType": "EventSignUpWindow",
                                                        "kind": "LinkedField",
                                                        "name": "clientEligibleSignUpWindows",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "opensAt",
                                                            "storageKey": null
                                                          },
                                                          (v7/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v104/*: any*/),
                                                        "kind": "ScalarField",
                                                        "name": "accessStatusForClient",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v104/*: any*/),
                                                        "kind": "ScalarField",
                                                        "name": "signUpStatusForClient",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "spotsAvailable",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "EventSeries",
                                                        "kind": "LinkedField",
                                                        "name": "eventSeries",
                                                        "plural": false,
                                                        "selections": [
                                                          (v58/*: any*/),
                                                          (v34/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Facility",
                                                            "kind": "LinkedField",
                                                            "name": "facility",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "FacilityCopyOverrides",
                                                                "kind": "LinkedField",
                                                                "name": "copyOverrides",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "NounOverride",
                                                                    "kind": "LinkedField",
                                                                    "name": "course",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "plural",
                                                                        "storageKey": null
                                                                      },
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "singular",
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Department",
                                                                "kind": "LinkedField",
                                                                "name": "department",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v22/*: any*/),
                                                                  (v34/*: any*/),
                                                                  (v7/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v7/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Image",
                                                            "kind": "LinkedField",
                                                            "name": "image",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": "publicId",
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "renderingKey",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v7/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "eventSessions(first:1000)"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v64/*: any*/),
                            "concreteType": "TimeSlotConnection",
                            "kind": "LinkedField",
                            "name": "timeSlots",
                            "plural": false,
                            "selections": [
                              (v62/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlotEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeSlot",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v40/*: any*/),
                                      (v66/*: any*/),
                                      (v103/*: any*/),
                                      (v77/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "holeOffset",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "groupLabel",
                                        "storageKey": null
                                      },
                                      (v78/*: any*/),
                                      (v79/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimeSlotBlock",
                                        "kind": "LinkedField",
                                        "name": "block",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v43/*: any*/),
                                          (v57/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BlockSeries",
                                            "kind": "LinkedField",
                                            "name": "blockSeries",
                                            "plural": false,
                                            "selections": [
                                              (v80/*: any*/),
                                              (v34/*: any*/),
                                              (v58/*: any*/),
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v81/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          (v28/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "memberOverride",
                                            "value": [
                                              "NONE",
                                              "WARN"
                                            ]
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "memberVisibility",
                                            "value": "SLOTS_AND_RESTRICTION_INLINE"
                                          },
                                          (v31/*: any*/)
                                        ],
                                        "concreteType": "SlotBookingRulesConnection",
                                        "kind": "LinkedField",
                                        "name": "bookingRules",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SlotBookingRulesEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v11/*: any*/),
                                                  (v7/*: any*/),
                                                  (v34/*: any*/),
                                                  (v35/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v37/*: any*/)
                                                    ],
                                                    "type": "BookingRestrictionRule",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "bookingRules(bookingType:[\"STANDARD\"],memberOverride:[\"NONE\",\"WARN\"],memberVisibility:\"SLOTS_AND_RESTRICTION_INLINE\",type:[\"RESTRICTION\"])"
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BookingConnection",
                                        "kind": "LinkedField",
                                        "name": "bookings",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v11/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "canUpdate",
                                                    "storageKey": null
                                                  },
                                                  (v84/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "ownerClient",
                                                    "plural": false,
                                                    "selections": [
                                                      (v11/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": (v53/*: any*/),
                                                        "type": "Member",
                                                        "abstractKey": null
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": (v53/*: any*/),
                                                        "type": "Customer",
                                                        "abstractKey": null
                                                      },
                                                      (v99/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v105/*: any*/),
                                                    "type": "StandardBooking",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v105/*: any*/),
                                                    "type": "DiningBooking",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v105/*: any*/),
                                                    "type": "LessonBooking",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": (v85/*: any*/),
                                                    "concreteType": "RoundConnection",
                                                    "kind": "LinkedField",
                                                    "name": "rounds",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "RoundEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "CourseLayout",
                                                                "kind": "LinkedField",
                                                                "name": "courseLayout",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v69/*: any*/),
                                                                  (v7/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "TransportationType",
                                                                "kind": "LinkedField",
                                                                "name": "transportationType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v69/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "customCode",
                                                                    "storageKey": null
                                                                  },
                                                                  (v34/*: any*/),
                                                                  (v7/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v86/*: any*/),
                                                              (v7/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": "rounds(noShowStatus:[\"PRESENT\"])"
                                                  },
                                                  (v7/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v82/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v68/*: any*/),
                                        "concreteType": "SlotRate",
                                        "kind": "LinkedField",
                                        "name": "playerRateForMembershipType",
                                        "plural": false,
                                        "selections": (v106/*: any*/),
                                        "storageKey": null
                                      },
                                      (v76/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSlot",
                                        "kind": "LinkedField",
                                        "name": "eventSlot",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v83/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v93/*: any*/),
                                      (v94/*: any*/),
                                      {
                                        "alias": "waitlistRestrictions",
                                        "args": (v95/*: any*/),
                                        "concreteType": "SlotBookingRulesConnection",
                                        "kind": "LinkedField",
                                        "name": "bookingRules",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SlotBookingRulesEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v102/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                                      },
                                      {
                                        "condition": "isCustomer",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": (v75/*: any*/),
                                            "concreteType": "CourseLayoutConnection",
                                            "kind": "LinkedField",
                                            "name": "permittedCourseLayouts",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CourseLayoutEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseLayout",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v69/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "memberVisible",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "enabled",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "default",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "permittedCourseLayouts(first:10,memberVisible:true)"
                                          },
                                          {
                                            "alias": null,
                                            "args": [
                                              (v74/*: any*/)
                                            ],
                                            "concreteType": "TransportationType",
                                            "kind": "LinkedField",
                                            "name": "transportationTypes",
                                            "plural": true,
                                            "selections": [
                                              (v7/*: any*/),
                                              {
                                                "alias": "nineHolePrice",
                                                "args": (v70/*: any*/),
                                                "kind": "ScalarField",
                                                "name": "totalPrice",
                                                "storageKey": "totalPrice(holeCount:\"NINE\")"
                                              },
                                              {
                                                "alias": "eighteenHolePrice",
                                                "args": (v72/*: any*/),
                                                "kind": "ScalarField",
                                                "name": "totalPrice",
                                                "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
                                              }
                                            ],
                                            "storageKey": "transportationTypes(memberVisible:true)"
                                          },
                                          {
                                            "alias": "rates",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "highestPrecedentOnly",
                                                "value": true
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "nonPlayingHost",
                                                "value": false
                                              },
                                              (v67/*: any*/)
                                            ],
                                            "concreteType": "SlotRate",
                                            "kind": "LinkedField",
                                            "name": "playerRates",
                                            "plural": true,
                                            "selections": (v106/*: any*/),
                                            "storageKey": "playerRates(highestPrecedentOnly:true,nonPlayingHost:false,type:\"CUSTOMER\")"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "requestConfigs",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "alias": "requestRestrictions",
                                            "args": (v88/*: any*/),
                                            "concreteType": "SlotBookingRulesConnection",
                                            "kind": "LinkedField",
                                            "name": "bookingRules",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SlotBookingRulesEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v33/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v11/*: any*/),
                                                      (v7/*: any*/),
                                                      (v34/*: any*/),
                                                      (v35/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v36/*: any*/),
                                                          (v101/*: any*/),
                                                          (v107/*: any*/)
                                                        ],
                                                        "type": "RequestRule",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "bookingRules(type:[\"REQUEST\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "requestConfigs",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "alias": "configuredRequestRestrictions",
                                            "args": (v88/*: any*/),
                                            "concreteType": "SlotBookingRulesConnection",
                                            "kind": "LinkedField",
                                            "name": "requestWindowBookingRules",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SlotBookingRulesEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v33/*: any*/),
                                                  (v90/*: any*/),
                                                  (v91/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v11/*: any*/),
                                                      (v7/*: any*/),
                                                      (v34/*: any*/),
                                                      (v35/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v36/*: any*/),
                                                          (v92/*: any*/),
                                                          (v38/*: any*/),
                                                          (v37/*: any*/),
                                                          (v101/*: any*/),
                                                          (v107/*: any*/)
                                                        ],
                                                        "type": "RequestRule",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v98/*: any*/),
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "alias": "requestRestrictions",
                                "args": (v88/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "bookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v33/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v7/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v36/*: any*/),
                                              (v101/*: any*/),
                                              (v108/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "bookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "configuredRequestRestrictions",
                                "args": (v97/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "requestWindowBookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v33/*: any*/),
                                      (v90/*: any*/),
                                      (v91/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v7/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v36/*: any*/),
                                              (v92/*: any*/),
                                              (v38/*: any*/),
                                              (v37/*: any*/),
                                              (v101/*: any*/),
                                              (v108/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "536990b669ddb3275aef979af5ed4178",
    "id": null,
    "metadata": {},
    "name": "TimeSlotListInternalQuery",
    "operationKind": "query",
    "text": "query TimeSlotListInternalQuery(\n  $facilityId: ID!\n  $courseIds: [ID]\n  $date: Date!\n  $memberId: ID!\n  $membershipTypeId: ID!\n  $isCustomer: Boolean!\n  $requestConfigs: Boolean!\n) {\n  session {\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        club {\n          id\n          visibility\n          supportsPublic\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  node(id: $facilityId) {\n    id\n    __typename\n    ... on Facility {\n      ...getFacilityMemberPermissions_facility\n      ...useGetCanClientFulFillRequests_facility\n      courses {\n        count\n      }\n      club {\n        supportsPublic\n        id\n      }\n      type\n      agendas(dateLte: $date, dateGte: $date) {\n        edges {\n          node {\n            id\n            date\n            queueSlot {\n              id\n              queueCount: bookings {\n                count\n              }\n            }\n            memberNote {\n              id\n              header\n              body\n              status\n            }\n            blockingRestrictions: bookingRules(type: [RESTRICTION], bookingType: [STANDARD], isBlocking: true, courseIds: $courseIds, memberVisibility: [RESTRICTION_ONLY, SLOTS_AND_RESTRICTION, NONE]) {\n              edges {\n                liftAt\n                node {\n                  __typename\n                  id\n                  name\n                  displayName\n                  ... on BookingRestrictionRule {\n                    memberMessage\n                    visibilityColor\n                    memberVisibility\n                    liftBookingRuleWindow {\n                      daysAhead\n                      time\n                      id\n                    }\n                    slotCriteria {\n                      allDay\n                      startAt\n                      endAt\n                      courses {\n                        count\n                        edges {\n                          node {\n                            id\n                            name\n                          }\n                        }\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n            }\n            infoRestrictions: bookingRules(type: [RESTRICTION], isBlocking: false, memberVisibility: [RESTRICTION_ONLY, SLOTS_AND_RESTRICTION], courseIds: $courseIds) {\n              edges {\n                liftAt\n                node {\n                  __typename\n                  id\n                  name\n                  displayName\n                  ... on BookingRestrictionRule {\n                    memberMessage\n                    visibilityColor\n                    memberVisibility\n                    slotCriteria {\n                      allDay\n                      startAt\n                      endAt\n                      courses {\n                        count\n                        edges {\n                          node {\n                            name\n                            id\n                          }\n                        }\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n            }\n            waitlistRestrictions: bookingRules(type: [WAITLIST], courseIds: $courseIds) {\n              edges {\n                liftAt\n                node {\n                  __typename\n                  id\n                }\n              }\n            }\n            blocks(first: 1000, isVisibleToMembers: true) {\n              edges {\n                node {\n                  id\n                  startAt\n                  durationMins\n                  blockSeries {\n                    name\n                    color\n                    id\n                  }\n                  courses {\n                    edges {\n                      node {\n                        id\n                        name\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            events(courseIds: $courseIds) {\n              edges {\n                node {\n                  id\n                  eventSeries {\n                    name\n                    id\n                  }\n                  eventSessions(first: 1000) {\n                    edges {\n                      node {\n                        id\n                        startAt\n                        endAt\n                        courses {\n                          edges {\n                            node {\n                              id\n                              name\n                            }\n                          }\n                        }\n                        agenda {\n                          date\n                          id\n                        }\n                        name\n                        timeSlots {\n                          firstDateTime\n                          lastDateTime\n                        }\n                        ...TimeListEventsCard_EventSession\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            timeSlots(first: 1000, courseIds: $courseIds) {\n              firstDateTime\n              edges {\n                node {\n                  ...TimeSlotRow_Timeslot_2yMzXk\n                  id\n                  time\n                  dateTime\n                  playerRateForMembershipType(membershipTypeId: $membershipTypeId, type: CUSTOMER) {\n                    rate {\n                      __typename\n                      id\n                      name\n                      type\n                      code\n                    }\n                    nineHolePrice: totalGolfPrice(holeCount: NINE)\n                    eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n                  }\n                  permittedCourseLayouts(first: 10, memberVisible: true) {\n                    edges {\n                      node {\n                        id\n                        name\n                        holeCount\n                      }\n                    }\n                  }\n                  availability\n                  capacity(bookingType: STANDARD)\n                  usedCapacity\n                  block {\n                    id\n                    startAt\n                    durationMins\n                    blockSeries {\n                      isVisibleToMembers\n                      name\n                      color\n                      id\n                    }\n                    courses {\n                      edges {\n                        node {\n                          id\n                        }\n                      }\n                    }\n                  }\n                  course {\n                    id\n                    name\n                  }\n                  eventSlot {\n                    type\n                    eventSession {\n                      id\n                    }\n                    id\n                  }\n                  bookings {\n                    edges {\n                      node {\n                        __typename\n                        writeAccess\n                        rounds(noShowStatus: [PRESENT]) {\n                          edges {\n                            node {\n                              __typename\n                              player {\n                                id\n                                firstName\n                                lastName\n                                __typename\n                              }\n                              id\n                            }\n                          }\n                        }\n                        id\n                      }\n                    }\n                  }\n                  requestRestrictions: bookingRules(type: [REQUEST]) @skip(if: $requestConfigs) {\n                    edges {\n                      liftAt\n                      node {\n                        __typename\n                        id\n                        name\n                        displayName\n                        ... on RequestRule {\n                          memberMessage\n                          liftBookingRuleWindow {\n                            daysAhead\n                            time\n                            id\n                          }\n                          slotCriteria {\n                            allDay\n                            startAt\n                            endAt\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                  configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) @include(if: $requestConfigs) {\n                    edges {\n                      liftAt\n                      requestOpens\n                      requestCloses\n                      node {\n                        __typename\n                        id\n                        name\n                        displayName\n                        ... on RequestRule {\n                          memberMessage\n                          requestConfig {\n                            closedRequestMessage\n                            id\n                          }\n                          memberVisibility\n                          visibilityColor\n                          liftBookingRuleWindow {\n                            daysAhead\n                            time\n                            id\n                          }\n                          slotCriteria {\n                            allDay\n                            startAt\n                            endAt\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                  hiddenBlockingRestrictions: bookingRules(type: [RESTRICTION], bookingType: [STANDARD], isBlocking: true, memberVisibility: [RESTRICTION_ONLY, NONE]) {\n                    edges {\n                      liftAt\n                    }\n                  }\n                  hasHiddenBlockingRestriction\n                  waitlistRestrictions: bookingRules(type: [WAITLIST]) {\n                    edges {\n                      liftAt\n                      node {\n                        __typename\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            requestRestrictions: bookingRules(type: [REQUEST]) @skip(if: $requestConfigs) {\n              edges {\n                liftAt\n                node {\n                  __typename\n                  id\n                  name\n                  displayName\n                  ... on RequestRule {\n                    memberMessage\n                    liftBookingRuleWindow {\n                      daysAhead\n                      time\n                      id\n                    }\n                    slotCriteria {\n                      allDay\n                      startAt\n                      endAt\n                      courses {\n                        edges {\n                          node {\n                            id\n                          }\n                        }\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n            }\n            configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST], courseIds: $courseIds) @include(if: $requestConfigs) {\n              edges {\n                liftAt\n                requestOpens\n                requestCloses\n                node {\n                  __typename\n                  id\n                  name\n                  displayName\n                  ... on RequestRule {\n                    memberMessage\n                    requestConfig {\n                      closedRequestMessage\n                      id\n                    }\n                    memberVisibility\n                    visibilityColor\n                    liftBookingRuleWindow {\n                      daysAhead\n                      time\n                      id\n                    }\n                    slotCriteria {\n                      allDay\n                      startAt\n                      endAt\n                      courses {\n                        edges {\n                          node {\n                            id\n                          }\n                        }\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n            }\n            weatherConditions(first: 1000) {\n              edges {\n                node {\n                  startTime\n                  id\n                  weatherCategory\n                  probabilityOfPrecipitationInPercent\n                  measurementSystem\n                  temperature\n                  humidityInPercent\n                  windDegrees\n                  windSpeedInMph\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment InlineRestrictionsList_timeSlot on TimeSlot {\n  bookingRules(type: [RESTRICTION], bookingType: [STANDARD], memberVisibility: SLOTS_AND_RESTRICTION_INLINE, memberOverride: [NONE, WARN]) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        displayName\n        ... on BookingRestrictionRule {\n          visibilityColor\n        }\n      }\n    }\n  }\n}\n\nfragment PrivateTimeSlotCardWrapper_timeSlot on TimeSlot {\n  ...InlineRestrictionsList_timeSlot\n  id\n  availability\n  bookings {\n    edges {\n      node {\n        __typename\n        canUpdate\n        writeAccess\n        ownerClient {\n          __typename\n          ... on Member {\n            id\n          }\n          ... on Customer {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ... on StandardBooking {\n          status\n        }\n        ... on DiningBooking {\n          status\n        }\n        ... on LessonBooking {\n          status\n        }\n        rounds(noShowStatus: [PRESENT]) {\n          edges {\n            node {\n              __typename\n              courseLayout {\n                code\n                id\n              }\n              transportationType {\n                code\n                customCode\n                name\n                id\n              }\n              player {\n                id\n                firstName\n                lastName\n                __typename\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment PublicTimeSlotCardWrapper_Timeslot_2yMzXk on TimeSlot {\n  ...InlineRestrictionsList_timeSlot\n  permittedCourseLayouts(first: 10, memberVisible: true) {\n    edges {\n      node {\n        id\n        code\n        name\n        memberVisible\n        enabled\n        default\n        holeCount\n      }\n    }\n  }\n  playerRateForMembershipType(membershipTypeId: $membershipTypeId, type: CUSTOMER) {\n    rate {\n      __typename\n      id\n      name\n      type\n      code\n    }\n    nineHolePrice: totalGolfPrice(holeCount: NINE)\n    eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n  }\n  transportationTypes(memberVisible: true) {\n    id\n    nineHolePrice: totalPrice(holeCount: NINE)\n    eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n  }\n  rates: playerRates(highestPrecedentOnly: true, nonPlayingHost: false, type: CUSTOMER) {\n    rate {\n      __typename\n      id\n      name\n      type\n      code\n    }\n    nineHolePrice: totalGolfPrice(holeCount: NINE)\n    eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n  }\n}\n\nfragment TimeListEventsCard_EventSession on EventSession {\n  id\n  bookingsPublishedAt\n  displayTime\n  startAt\n  endAt\n  agenda {\n    date\n    id\n  }\n  event {\n    id\n    tags {\n      edges {\n        node {\n          name\n          id\n        }\n      }\n    }\n    clientEligibleSignUpWindows(clientId: $memberId) {\n      opensAt\n      id\n    }\n    accessStatusForClient(clientId: $memberId)\n    signUpStatusForClient(clientId: $memberId)\n    spotsAvailable\n    eventSeries {\n      color\n      name\n      facility {\n        copyOverrides {\n          course {\n            plural\n          }\n        }\n        department {\n          type\n          name\n          id\n        }\n        id\n      }\n      image {\n        publicId: renderingKey\n      }\n      id\n    }\n  }\n  ...useEventLocationLabel_Event\n}\n\nfragment TimeSlotRow_Timeslot_2yMzXk on TimeSlot {\n  id\n  time\n  dateTime\n  agenda {\n    date\n    id\n  }\n  availability\n  holeOffset\n  groupLabel\n  capacity(bookingType: STANDARD)\n  usedCapacity\n  block {\n    id\n  }\n  ...PublicTimeSlotCardWrapper_Timeslot_2yMzXk @include(if: $isCustomer)\n  ...PrivateTimeSlotCardWrapper_timeSlot\n  course {\n    id\n    name\n  }\n  bookings {\n    edges {\n      node {\n        __typename\n        id\n        canUpdate\n        writeAccess\n        ownerClient {\n          __typename\n          ... on Member {\n            id\n          }\n          ... on Customer {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ... on StandardBooking {\n          status\n        }\n        ... on DiningBooking {\n          status\n        }\n        ... on LessonBooking {\n          status\n        }\n        rounds(noShowStatus: [PRESENT]) {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useEventLocationLabel_Event on EventSession {\n  courses {\n    edges {\n      node {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  event {\n    eventSeries {\n      facility {\n        ...useFacilityCourseNoun_facility\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n\nfragment useGetCanClientFulFillRequests_facility on Facility {\n  club {\n    supportsPublic\n    id\n  }\n  privateBookingPermissionSet {\n    clientCanFulfillRequests\n    id\n  }\n  publicBookingPermissionSet {\n    clientCanFulfillRequests\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc161ec6cb52e60d7ffc93e36dc7a03c";

export default node;
